const envVars = {
    send_port: process.env.REACT_APP_SEND_PORT,
    recv_port: process.env.REACT_APP_RECV_PORT,
    websocket_protocol: process.env.REACT_APP_WEBSOCKET_PROTOCOL,
    host: process.env.REACT_APP_HOST,
    name: process.env.REACT_APP_ENV_NAME,
    version: process.env.REACT_APP_VERSION,
}
export default envVars